<label>{{ 'LABEL_PAISESVINCULADOS' | translate }}</label>
<ng-select [items]="paises" [multiple]="true" bindLabel="nome" bindValue="id" (add)="onAddItem($event)"
    placeholder="{{ 'LABEL_NENHUMPAISVINCULADO' | translate }}" (remove)="onRemoveItem($event)" name="pais"
    [(ngModel)]="paisesSelecionado">
</ng-select>